import { TCharacter, TChaser, TPlayer } from "../../data/character";
import { useGame } from "../../data/gameContext";
import { TTown } from "../../data/town";
import { mapTerrainColors, TDisplayMapTile, TMapTile } from "./mapTypes";
import './mapViewer.css'
import TownPopover from "./townPopover";
import { useState, useEffect } from "react";

interface IMapViewerProps {
    map: TMapTile[][];
    towns: TTown[];
    chasers: TChaser[];
    playerCharacter: TPlayer;
    width: number;
    height: number;
    tileSize: number;
}


export default function MapViewer(props: IMapViewerProps) {
    const { map, towns, chasers, playerCharacter, width, height, tileSize } = props;
    const [playerPos, setPlayerPos] = useState({location: {...playerCharacter.Location} });
    const {gameState} = useGame();

    useEffect(() => {
        setPlayerPos({ location: {...playerCharacter.Location}});
    }, [playerCharacter.Location]);

    let displayMap: TDisplayMapTile[][] = map.map((row) => row.map((tile) => ({
        Terrain: tile.Terrain,
        TownIndex: undefined,
        ChaserIndexes: []
    })));

    for (let townIndex = 0; townIndex < towns.length; townIndex++) {
        let town = towns[townIndex];
        let tile = displayMap[town.Location.y][town.Location.x];
        tile.TownIndex = townIndex;
    }

    for (let chaserIndex = 0; chaserIndex < chasers.length; chaserIndex++) {
        let chaser = chasers[chaserIndex];
        if (chaser.Location) {
            let tile = displayMap[chaser.Location.y][chaser.Location.x];
            tile.ChaserIndexes = [...tile.ChaserIndexes, chaserIndex];
        }
    }

    return (
        <div style={{
            display: "grid",
            gridTemplateColumns: `repeat(${width}, ${tileSize}px)`,
            gridTemplateRows: `repeat(${height}, ${tileSize}px)`,
            gap: "0px", 
            backgroundColor: "black",
            justifyContent: "center",
            position: "relative", 
        }}>
            {displayMap.flat().map((tile: TDisplayMapTile, index) => {
                return (
                    <div style={{
                        position: "relative",
                    }}>
                    <div
                        key={index}
                        className="tile"
                        style={{
                            width: tileSize,
                            height: tileSize,
                            backgroundColor: mapTerrainColors[tile.Terrain],
                            border: "1px solid #333",
                            position: "relative",
                        }}
                    >
                        {tile.TownIndex !== undefined && (
                            <TownPopover tile={tile} />
                        )}
                    </div>
                    {tile.TownIndex !== undefined && 
                        <div
                            style={{
                                position: "absolute",
                                top: "120%", 
                                left: "50%",
                                transform: "translate(-50%, 0)",
                                backgroundColor: "rgba(0, 0, 0, 0.7)",
                                color: "white",
                                padding: "4px 8px",
                                borderRadius: "4px",
                                fontSize: "12px",
                                pointerEvents: "none",
                                zIndex: 10,
                                textWrap: "nowrap",
                            }}
                        >
                            {tile.TownIndex !== undefined && gameState.GameTowns.length > tile.TownIndex ? gameState.GameTowns[tile.TownIndex].Name : ""}
                        </div>
                    }
                    </div>
                );
            })}

            {/* Character Icon */}
            <div
                className="player-icon"
                style={{
                    position: "absolute",
                    width: tileSize * 0.8, 
                    height: tileSize * 0.8,
                    left: (playerPos.location.x! + 8) * tileSize + tileSize * 0.1, 
                    top: playerPos.location.y! * tileSize + tileSize * 0.1,  
                    transition: "left 0.1s linear, top 0.1s linear",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "24px",
                }}
            >
                🤠
            </div>
        </div>
    );
}

 
  

